import { put, takeLatest } from "redux-saga/effects";
import { requestContactList } from "../../../services/contact";

import {
  fetchContactListFailure,
  fetchContactListRequest,
  fetchContactListSuccess,
} from "./../../reducers/contact";

export function* watchContactSaga() {
  yield takeLatest(fetchContactListRequest, fetchContactList);
}

/**
 *
 * @param {*} param0
 */
function* fetchContactList({ payload }) {
  try {
    const response = yield requestContactList(payload);
    yield put(fetchContactListSuccess(response));
  } catch (error) {
    yield put(fetchContactListFailure("Failed to get list of contact"));
  }
}
